<template>
  <div>
    <Banner />
    <div class="main-content">
      <div class="model-name">品质型农业</div>
      <div class="model-name-en mb30">Quality agriculture</div>
      <div class="base-info" v-html="html">
        
      </div>
      <div class="model-name mb30">农业资源优势</div>
      <div class="base-info" v-html="html">

      </div>
      <div class="model-name mb30">产业发展模式</div>
      <div class="base-info" v-html="html"></div>
    </div>
  </div>
</template>

<script>
import Banner from '../../components/Banner'
export default {
  components: {
    Banner
  },
  data() {
    return {
      html: `<p>现代服务业植入：电商、会展、品牌创建中心、冷链基地、产业强IP企业进驻</p>
        <p>国内领先的小产区品牌、三产融合的农业公园</p>
        <p>三产项目引领：京西国际生态产业商贸会展示范区；</p>
        <p>特色领先的一产基地：小杂粮、杏扁、生态中药、野生可食用菌、规模放养、规模高山大农业（错季蔬菜）等；特色二产展示：本土特色农产品及加工技术展示。</p>
        <p>大农业产业促进中心：农业大数据、产品标准化、育苗基地、植保中心、科研工作站等</p>
        <p>区位支持：地块处于高速路出口、周边配套优质农田、本土成体系的大商贸产业基础</p>
        <p>资源支持：本土物种丰富、项目地形地貌适合、气候优势明显、民间有摘采及食用习惯，地方产销初成体系。</p>`
    }
  }
}
</script>

<style scoped lang="scss">
  .company-name {
    line-height: 30px;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #666666;
    text-align: center;
  }
  .company-name-en {
    line-height: 20px;
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #999999;
    text-align: center;
  }
  .base-info {
    line-height: 30px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #999999;
    text-align: center;
    margin-bottom: 50px;
  }
</style>